module.exports = __webpack_public_path__ + "img/avatar.b7014db6.png";